var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreCrystalSm = function SvgStoreCrystalSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store-crystal-sm_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store-crystal-sm_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m6.204 16.028 2.221-2.755 2.44-3.023 2.44-3.025 2.222-2.756 6.509.48 3.172 16.871-17.16.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal-sm_svg__c)",
    stroke: "#000",
    d: "m15.527 4.47-2.222 2.755-2.44 3.025 14.343 11.57-3.172-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m21.981 4.972-7.018 8.583M25.208 21.82 18.46 9.22l-5.155-1.995"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal-sm_svg__d)",
    stroke: "#000",
    d: "m6.204 16.028 2.222-2.754 2.44-3.024 14.342 11.57-17.16.467z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m8.055 22.24 6.908-8.685M25.209 21.82 11.466 17.89l-3.04-4.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.71 19.402a3.4 3.4 0 0 1-.74-2.266c.066-1.357.942-2.176 1.112-2.329a3.6 3.6 0 0 1-2.33.665 3.6 3.6 0 0 1-2.264-1.037c.133.148.926 1.061.802 2.412-.12 1.31-1.012 2.053-1.171 2.182a4.14 4.14 0 0 1 2.46-.513 4.14 4.14 0 0 1 2.134.884zM15.079 17.615c-.082-.102-.4-.52-.372-1.132a1.71 1.71 0 0 1 .557-1.164c-.116.083-.55.377-1.165.333a1.8 1.8 0 0 1-1.132-.517c.066.073.462.531.4 1.206a1.63 1.63 0 0 1-.586 1.092c.157-.09.617-.323 1.23-.257.55.06.921.326 1.066.442z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal-sm_svg__c",
    x1: 20.689,
    x2: 10.467,
    y1: 3.027,
    y2: 23.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal-sm_svg__d",
    x1: 15.967,
    x2: 7.523,
    y1: 8.623,
    y2: 31.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "store-crystal-sm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 0 .34 13.766l13.193 18.84 19.66-13.766z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "store-crystal-sm_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.942-4.715-5.781 14.697l18.525 26.455L40.466 21.74z"
  })))));
};
export default SvgStoreCrystalSm;